import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/CSS/index.css'
import noPermission from "./layouts/noPermission.vue";
import ordinary from "./layouts/ordinary.vue";
/**
 * 公共方法
 * */

import './assets/JS/el_selecct'
import "./assets/JS/tableCopy";
// import './assets/JS/SSO'
import "./router/permission";



Vue.component("noPermission", noPermission);
Vue.component("ordinary", ordinary);

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  el: '#app',
  render: function (h) {
    return h(App)
  }
}).$mount('#app')